import React from "react"

import { StyledIconContainer } from "./styled"

const IconContainer = (props) => <StyledIconContainer {...props} />

export default IconContainer
